import { render, staticRenderFns } from "./advertiser.vue?vue&type=template&id=d7c5b65c&scoped=true&"
import script from "./advertiser.vue?vue&type=script&lang=js&"
export * from "./advertiser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c5b65c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7c5b65c')) {
      api.createRecord('d7c5b65c', component.options)
    } else {
      api.reload('d7c5b65c', component.options)
    }
    module.hot.accept("./advertiser.vue?vue&type=template&id=d7c5b65c&scoped=true&", function () {
      api.rerender('d7c5b65c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/advertiser.vue"
export default component.exports